<h1 mat-dialog-title class="pv-dialog-title">
    <span class="pv-dialog-title-text">Move {{ data.imageKeys.length }} Image{{ data.imageKeys.length === 1 ? '' : 's' }}</span>
</h1>

<div mat-dialog-content class="pv-dialog-body">

    <p class="mat-caption" *ngIf="crossSampleMode">
        Moving to: {{ destinationSampleLabel }}
        <button mat-button type="button" (click)="openSamplePicker()">Change sample</button>
    </p>

    <div class="evaluation-list">

        <div class="pv-evaluation-row"
            *ngFor="let evalu of (crossSampleMode ? evaluations : data.evaluations); trackBy: trackEvaluation"
            (click)="selectDestination(evalu)">

            <div class="evaluation-title">
                <h4 [class.text-muted]="!evalu.label">{{ evalu.label || 'Unlabeled' }}</h4>
                <span class="eval-code text-muted">{{ evalu.code | describeCode : 4 }}</span>
            </div>

            <div class="evaluation-status" [ngSwitch]="evalu | getEvaluationStatus">
                <span *ngSwitchCase="'PENDING'" class="text-muted">
                    <mat-icon>event</mat-icon> Pending
                </span>
                <span *ngSwitchCase="'ONGOING'" class="text-accent">
                    <mat-icon>event_note</mat-icon> Ongoing
                </span>
                <span *ngSwitchCase="'COMPLETE'" class="text-primary">
                    <mat-icon>event_available</mat-icon> Completed
                </span>
                <span *ngSwitchDefault class="text-warn">
                    <mat-icon>event_busy</mat-icon> Invalid
                </span>
            </div>

        </div>

        <p class="mat-caption" *ngIf="(crossSampleMode ? evaluations : data.evaluations).length === 0">
            {{ crossSampleMode ? 'No evaluations on ' + destinationSampleLabel + '.' : 'No other evaluations on this sample.' }}
        </p>

    </div>

    <div class="escape-hatch-region" *ngIf="!crossSampleMode">
        <p class="mat-caption">Not on this list?</p>
        <button mat-stroked-button type="button" (click)="openSamplePicker()">
            Different sample
        </button>
    </div>

</div>

<div mat-dialog-actions align="end" class="pv-dialog-footer">
    <button mat-button (click)="cancel()">Cancel</button>
</div>
